import { jsx as m, Fragment as k, jsxs as b } from "react/jsx-runtime";
import { cn as y } from "../../lib/utils.mjs";
import M from "./PaginationItem/PaginationItem.mjs";
import N from "./PaginationPrevious/PaginationPrevious.mjs";
import j from "./PaginationLink/PaginationLink.mjs";
import E from "./PaginationEllipsis/PaginationEllipsis.mjs";
import A from "./PaginationNext/PaginationNext.mjs";
import C from "./PaginationContent/PaginationContent.mjs";
const F = ({
  className: w,
  onPageChange: p,
  paginationParam: h = "page",
  currentPage: n,
  totalPages: i = 10,
  baseUrl: o,
  as: s = "link",
  ...u
}) => {
  const d = (f) => {
    p == null || p(f);
  }, v = () => {
    const f = [];
    if (i > 6) {
      if (typeof window < "u" && window.innerWidth < 376)
        return n > 3 && n < i - 1 ? f.push(1, "...", n, "...", i) : n === i - 1 ? f.push(1, "...", n, i) : n === i ? f.push(1, "...", i - 1, i) : f.push(n, "...", i), f;
      n <= 2 ? f.push(1, 2, 3, "...", i) : n <= 3 ? f.push(1, 2, 3, 4, "...", i) : n > i - 2 ? f.push(1, "...", i - 2, i - 1, i) : n > i - 3 ? (console.log("currentPage", n), f.push(1, "...", i - 3, i - 2, i - 1, i)) : f.push(1, "...", n - 1, n, n + 1, "...", i);
    } else
      for (let l = 1; l <= i; l++)
        f.push(l);
    return f;
  };
  return /* @__PURE__ */ m(k, { children: /* @__PURE__ */ m(
    "nav",
    {
      role: "navigation",
      "aria-label": "pagination",
      className: y("mx-auto flex w-full justify-center", w),
      ...u,
      children: /* @__PURE__ */ b(C, { variant: "default", children: [
        /* @__PURE__ */ m(
          N,
          {
            onClick: () => d(Math.max(1, n - 1)),
            disabled: n === 1,
            variant: "button",
            as: s,
            url: o,
            page: Math.max(1, n - 1),
            paginationParam: h
          }
        ),
        v().map((f, x) => /* @__PURE__ */ m(M, { children: typeof f == "number" ? /* @__PURE__ */ m(
          j,
          {
            isActive: f === n,
            onClick: () => d(f),
            as: s,
            url: o,
            paginationParam: h,
            page: f,
            children: f
          }
        ) : /* @__PURE__ */ m(E, {}) }, x)),
        /* @__PURE__ */ m(
          A,
          {
            onClick: () => d(Math.min(i, n + 1)),
            disabled: n === i,
            as: s,
            url: o,
            page: Math.min(i, n + 1),
            paginationParam: h
          }
        )
      ] })
    }
  ) });
};
F.displayName = "Pagination";
export {
  F as default
};
//# sourceMappingURL=Pagination.mjs.map
